


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class LoadingButton extends Vue {
  @Prop({ type: String, default: "default" }) variant?: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
}
